module.exports = __webpack_public_path__ + "static/media/close-icon.9ba72e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/close-icon.png
// module id = 1979
// module chunks = 6